import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from 'rxjs/operators';
import { EnvService } from "@gea-waldviertler-website/shop-lib";
import { VersionCheckService } from "../../version-check.service";

@Injectable()
export class HttpVersionInterceptor implements HttpInterceptor {
  private envService = inject(EnvService)
  private versionCheckService = inject(VersionCheckService)

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // nur gea-api-Requests auswerten
    if (! (request.url.startsWith(this.envService.config.apiURL) || request.url.startsWith(this.envService.config.apiURL_SSR))) {
      return next.handle(request)
    }

    return next.handle(request).pipe(tap(event => {
      if (event instanceof HttpResponse) {
        this.versionCheckService.check(event.headers.get('X-Frontend-Version'))
      }
    }))
  }
}
